import React, { Fragment } from 'react'
import { Map } from 'immutable'
import { Field } from 'redux-form/immutable'

import Button from 'app/components/ButtonDefault'
import Input from 'app/components/Input'
import { IReviewsSurveyOpenEndedQuestionSectionProps } from './interface'
import Delete from 'app/components/SVGS/Delete'
import { trimmed } from 'helpers/reviews'
import IconButton from 'app/domains/common/IconButton'

import './styles.scss'

const bc = 'reviews-survey-open-ended-question-section'

const ReviewsSurveyOpenEndedQuestionSection: React.FC<IReviewsSurveyOpenEndedQuestionSectionProps> = ({
  fields,
  min,
  validateTextArea,
  isPublished,
  t,
}) => {
  return (
    <div>
      {fields.map((member: string, index: number) => {
        return (
          <Fragment key={`${fields.name}.${index}`}>
            <div className={`${bc}__title`}>
              <h4 style={{ marginRight: '8px' }}>{`Question ${index + 1}`}</h4>
              {index >= min && (
                <IconButton onClick={() => fields.remove(index)} disabled={isPublished}>
                  <Delete />
                </IconButton>
              )}
            </div>
            <Field
              name={`${member}.userQuestion`}
              component={Input}
              label={`${t('User question')}:`}
              placeholder={t('Write user question')}
              validate={validateTextArea}
              disabled={isPublished}
              normalize={trimmed}
            />
            <Field
              name={`${member}.reviewerQuestion`}
              component={Input}
              label={`${t('Reviewer question')}:`}
              placeholder={t('Write reviewer question')}
              validate={validateTextArea}
              disabled={isPublished}
              normalize={trimmed}
            />
          </Fragment>
        )
      })}
      <Button
        xs
        outline
        isLast
        onClick={() => fields.push(Map({ userQuestion: '', reviewerQuestion: '' }))}
        disabled={isPublished}
        title={isPublished ? t('Button is disabled because survey already is published') : undefined}
      >
        + {t('Add Question')}
      </Button>
    </div>
  )
}

export default ReviewsSurveyOpenEndedQuestionSection
